import { connect } from 'react-redux'
import compose from 'recompose/compose'
import SupplementalMediaButton from 'aria-viewer/tour/components/buttons/supplementalmedia/supplementalMediaButton'
import MobileDetect from 'aria-viewer/utils/mobileDetect'
import { SCREEN_SIZES } from 'aria-viewer/tour/constants'
import { showSupplementalMediaView } from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import { setCountDown, setMute } from 'aria-viewer/audiomanager/countDownActions'
import { setSupplementalMediaButtonHover } from 'aria-viewer/tour/tourActions'
import { playAudio, AUDIO_SUPP } from 'aria-viewer/audiomanager/audioManagerActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { Capabilities, displayFeatureBasedOnViewportSize } from 'aria-viewer/utils/capabilities'
import React from 'react'

const mapDispatchToProps = dispatch => ({
    setCountDown: status => dispatch(setCountDown(status)),

    setMute: status => dispatch(setMute(status)),

    showSupplementalMediaView: (stopId, mediaType) => {
        let media
        dispatch(
            showSupplementalMediaView({
                stopid: stopId,
                mediaType,
                media,
            })
        )
        dispatch(playAudio(AUDIO_SUPP))
    },

    setSupplementalMediaButtonHover: isHover => {
        dispatch(setSupplementalMediaButtonHover(isHover))
    },

    onMouseLeave: () => {
        dispatch(setSupplementalMediaButtonHover(false))
    },
})

const mapStateToProps = (state, { mediaListByType: { photos, panoramas, videos }, pointInfo: { avatar_url } }) => ({
    hover: state.getIn(['tour', 'isSupplementalMediaButtonHover']),
    supplementalMediaCount: photos.length + panoramas.length + videos.length,
    photoThumbnailUrl:
        photos[0]?.network === 'instagram'
            ? `${process.env.REACT_APP_INSTAGRAM_URL}/${photos[0]?.url}`
            : photos[0]?.thumburl || photos[0]?.urls?.tiny,
    displaySuppMediaDesktop:
        displayFeatureBasedOnViewportSize(Capabilities.SUPPLEMENTAL_MEDIA_DESKTOP, {
            viewportHeight: state.getIn(['device', 'viewportHeight']),
            viewportWidth: state.getIn(['device', 'viewportWidth']),
        }) &&
        // Not in intro media
        state.getIn(['tour', 'altMainMedia']) == null &&
        // Not counting down
        state.getIn(['countdown']).playingCountdown === false &&
        // Count down has completed
        state.getIn(['countdown']).playedCountdown === true &&
        // The mute button is not appearing
        state.getIn(['countdown']).showMute === false,
    viewportWidth: state.getIn(['device', 'viewportWidth']),
    photos,
    panoramas,
    videos,
    isDescriptionVisible:
        state.getIn(['tour', 'toggleDescriptionVisible']) ||
        (state.getIn(['avatar', 'isAvatarShown']) && state.getIn(['audioManager', 'audioPlaying']) && avatar_url != ''),
})

const mergeProps = (state, actions, ownProps) => ({
    ...state,
    ...actions,
    ...ownProps,

    onMouseEnter: () => {
        //if it's mobile or screen width smaller than 1024 don't show hover preview
        if (MobileDetect.mobile() || state.viewportWidth <= SCREEN_SIZES.size_1024) return
        actions.setSupplementalMediaButtonHover(true)
    },

    onPanoThumbnailClick: _ => {
        actions.showSupplementalMediaView(ownProps.currentStop.stopid, 'pano')
    },

    onVideoThumbnailClick: _ => {
        actions.showSupplementalMediaView(ownProps.currentStop.stopid, 'video')
    },

    onPhotoThumbnailClick: _ => {
        actions.showSupplementalMediaView(ownProps.currentStop.stopid, 'photo')
    },
})

const shouldRenderComponent = Component => ({ supplementalMediaCount, displaySuppMediaDesktop, ...props }) =>
    displaySuppMediaDesktop && supplementalMediaCount > 0 ? <Component {...props} /> : null

export default compose(
    connect(mapSelectorsToProps(['currentStop', 'mediaListByType', 'pointInfo'])),
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    shouldRenderComponent
)(SupplementalMediaButton)
